import { Receipt } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RemittanceBannerProps {
  remittanceId: string;
  remittanceDate: string;
}

export function RemittanceBanner({ remittanceId, remittanceDate }: RemittanceBannerProps) {
  const { t } = useTranslation();

  return (
    <div
      className='flex items-center justify-between gap-3 rounded-2xl px-4 py-3.5 mb-5 border border-solid'
      style={{
        backgroundColor: 'hsla(152,60%,48%,0.08)',
        borderColor: 'hsla(152,60%,38%,0.3)',
      }}
    >
      {/* Left: icon + label + date */}
      <div className='flex items-center gap-3'>
        <div
          className='flex items-center justify-center w-8 h-8 rounded-lg'
          style={{ backgroundColor: 'hsla(152,60%,48%,0.15)' }}
        >
          <Receipt className='h-4 w-4' strokeWidth={1.5} style={{ color: 'hsl(152,60%,38%)' }} />
        </div>
        <div>
          <span
            className='text-[13px] font-bold block'
            style={{ color: 'hsl(152,60%,32%)' }}
          >
            {String(t('paid'))}
          </span>
          <span
            className='text-[11px] opacity-80'
            style={{ color: 'hsl(152,60%,32%)' }}
          >
            {remittanceDate}
          </span>
        </div>
      </div>

      {/* Right: remittance ID badge */}
      <span
        className='text-[11px] font-semibold px-2.5 py-1 rounded-lg border'
        style={{
          backgroundColor: 'hsla(152,60%,48%,0.12)',
          borderColor: 'hsla(152,60%,38%,0.3)',
          color: 'hsl(152,60%,32%)',
        }}
      >
        #{remittanceId}
      </span>
    </div>
  );
}
